import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-community-service',
  templateUrl: './community-service.component.html',
  styleUrls: ['./community-service.component.sass']
})
export class CommunityServiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    document.querySelector(".__page-root").scrollIntoView(true);
  }

}
